import { useState } from 'react';
import { Icon } from '../../../shared/Icon';
import { speakNorwegian } from '../../../shared/speech';
import type { ExercisePluginProps } from '../types';
import { openResponseModel } from '../openResponseModel';
import { useSpeechInput } from '../useSpeechInput';

export function OpenResponseExercise({ exercise, onComplete, showToast }: ExercisePluginProps) {
  const [answer, setAnswer] = useState('');
  const [modelsVisible, setModelsVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const model = openResponseModel(exercise);
  const speech = useSpeechInput(answer, setAnswer, showToast);

  async function finish() {
    setSaving(true);
    await onComplete({
      response: { answer },
      result: { evaluated: false, evaluationStatus: 'not-implemented' },
      evidence: []
    });
  }

  return <>
    <p className="exercise-kicker">{model.kicker}</p>
    <h2 className="exercise-title">{model.title}</h2>
    <p className="exercise-intro">{model.intro}</p>
    <div className="prompt-card"><span className="prompt-label">{model.promptLabel}</span><blockquote>«{model.prompt}»</blockquote></div>
    {model.suggestions.length > 0 && <div className="must-use"><span>BRUK GJERNE</span><div className="word-chips">{model.suggestions.map(word => <i key={word}>{word}</i>)}</div></div>}
    <textarea className="answer-area" value={answer} onChange={event => setAnswer(event.target.value)} placeholder="Skriv svaret ditt …" aria-label="Svaret ditt" />
    <div className="speak-actions">
      {model.allowMicrophone && <button className={`mic-button ${speech.recording ? 'recording' : ''}`} onClick={speech.toggle}><Icon name="mic" />{speech.recording ? 'Stopp opptak' : 'Start opptak'}</button>}
      <button className="reveal-button" disabled={!answer.trim()} onClick={() => setModelsVisible(true)}>Sammenlign med modell</button>
    </div>
    {modelsVisible && <>
      {model.models.map((example, index) => <div className="model-answer" key={example}><span>{index === 0 ? 'EN MULIG MODELL' : 'EN ANNEN MULIGHET'}</span><p>«{example}»</p><button className="listen-button" onClick={() => speakNorwegian(example)}><Icon name="volume" /> Hør modellen</button></div>)}
      <div className="feedback-box evaluation-pending"><span className="evaluation-status">AI-VURDERING · IKKE KLAR</span><h4>Svaret ditt er ikke vurdert.</h4><p>Modellen er en referanse, ikke eneste fasit. Vi lagrer ikke korrekthet eller læringsevidens for dette åpne svaret før en evaluator er implementert.</p></div>
      <div className="speak-actions"><button className="exercise-next" disabled={saving} onClick={finish}>Fortsett <Icon name="arrow" /></button></div>
    </>}
  </>;
}
